import { useQuery } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";

export function useOnboardingStateQuery(enabled: boolean = true) {
  return useQuery({
    ...orpc.onboarding.getState.queryOptions({ input: {} }),
    enabled,
  });
}
